module.exports = __webpack_public_path__ + "static/img/supermarket-small.2dc9314.jpg";